import * as React from "react";
import Pages from "./pages";
import { IPaginationProps } from "./pagination.types";

/// <summary>
/// Renders pagination arrows and buttons
/// </summary>
const Pagination: React.FC<IPaginationProps> = ({
  onPageSelect,
  totalItems,
  pageSize,
  pageNumber,
}) => {
  const totalPages = Math.ceil(totalItems / pageSize);

  const boundedCurrentPage = pageNumber > totalPages ? totalPages : pageNumber;

  const fullPaginationOptions = {
    totalItems,
    pageSize,
    pageNumber: boundedCurrentPage,
    totalPages,
  };

  return (
    <ul className="d-flex pagination-ul p-0 text-center">
      <Pages
        paging={fullPaginationOptions}
        onPageSelect={onPageSelect}
        numberOfButtonsToShow={6}
      />
      {pageNumber < totalPages && (
        // eslint-disable-next-line
        <li className="pagination-li--next">
          <a
            onClick={() => onPageSelect(pageNumber + 1)}
            className="text-underline pagination-link"
          >
            Next
          </a>
        </li>
      )}
    </ul>
  );
};

export default Pagination;
